import isInt from 'validator/lib/isInt';
import isURL from 'validator/lib/isURL';
import isIn from 'validator/lib/isIn';
import isBoolean from 'validator/lib/isBoolean';

const validator = {
  isInt: isInt,
  isURL: isURL,
  isIn: isIn,
  isBoolean: isBoolean
}
// eslint-disable-next-line
require('url-polyfill');
var availableControls = ['scrub', 'playpause', 'rewind', 'volume', 'timestamp', 'share', 'quality', 'fullscreen', 'subtitle', 'playlist', 'chapters'];

function filterConfig(dataset = {}) {
  var config = {};
  // video
  config.videoId = dataset.videoId ? dataset.videoId : null;
  config.videoUrl = dataset.videoUrl && validator.isURL(dataset.videoUrl + '', {
    allow_underscores: true
  }) ? dataset.videoUrl : null;
  // player
  config.autoplay = validator.isIn(dataset.autoplay + '', ['true', 'viewable']) ? dataset.autoplay : false;
  config.mute = boolvalFallbackFalse(dataset.mute);
  config.noTracking = boolvalFallbackFalse(dataset.noTracking);
  config.postermode = validator.isBoolean(dataset.postermode + '') ? dataset.postermode + '' === 'true' : false;
  config.volume = validator.isInt(dataset.volume + '', {
    min: 0,
    max: 100
  }) ? parseInt(dataset.volume) : 75;
  config.allowFullscreen = boolvalFallbackTrue(dataset.allowFullscreen);
  config.repeat = boolvalFallbackFalse(dataset.repeat);
  config.shareUrl = dataset.shareUrl || false;
  config.referrer = dataset.referrer;
  // share to website setting
  const allowedShareSites = [
    'facebook',
    'twitter',
    'pinterest',
    'email',
    'tumblr',
    'linkedin',
    'reddit'
  ];
  if (typeof dataset.socialshare === 'string' && dataset.socialshare) {
    config.socialshare = [];
    var sitesToShare = dataset.socialshare.split(',');
    sitesToShare.forEach(function (website) {
      if (allowedShareSites.indexOf(website) !== -1) {
        config.socialshare.push(website);
      } else {
        console.log('Not available sharing on this website: ' + website);
      }
    });
  }
  // quality
  config.quality = dataset.quality;
  // controls
  config.controls = dataset.controls + '' !== 'false';
  config.hideControls = {};
  if (typeof dataset.hideControlElements === 'string' && dataset.hideControlElements) {
    var hiddenControls = dataset.hideControlElements.split(',')
    hiddenControls.forEach(function (control) {
      if (availableControls.indexOf(control) !== -1) {
        config.hideControls[control] = true;
      } else {
        console.log('Unrecognised control item: ' + control);
      }
    });
  }
  // presentation
  config.slideSeeking = dataset.slideSeeking + '' !== 'false';
  config.maxSeek = validator.isInt(dataset.maxSeek + '') ? parseInt(dataset.maxSeek) : false;
  if (dataset.presentationMode && validator.isIn(dataset.presentationMode + '', ['SBS', 'PIP', 'Single'])) {
    config.presentationMode = dataset.presentationMode;
  }
  if (dataset.presentationPrimaryComponent && validator.isIn(dataset.presentationPrimaryComponent, ['slide', 'video'])) {
    config.presentationPrimaryComponent = dataset.presentationPrimaryComponent;
  }
  config.presentationZoomed = boolvalFallbackFalse(dataset.presentationZoomed);

  // language
  config.lang = dataset.lang || navigator.language || 'en';
  // Dimension config
  if (dataset.aspectratio && /^\d+:\d+$/.test(dataset.aspectratio)) {
    config.aspectratio = dataset.aspectratio;
    config.width = validator.isInt(dataset.width + '') || /^\d+%$/.test(dataset.width) ? dataset.width : '100%';
  } else {
    config.height = validator.isInt(dataset.height + '') || /^\d+%$/.test(dataset.height) ? dataset.height : undefined;
    config.width = validator.isInt(dataset.width + '') || /^\d+%$/.test(dataset.width) ? dataset.width : '100%';
  }
  config.stretching = validator.isIn(dataset.stretching + '', ['uniform', 'exactfit', 'fill', 'none']) ? dataset.stretching : 'uniform'
  // audio
  config.audioOnly = false
  if (dataset.audioOnly && dataset.audioOnly + '' === 'true') {
    config.height = 44
    config.audioOnly = true;
  }
  // title, description and chapters
  config.showTitle = boolvalFallbackTrue(dataset.showTitle)
  config.showDescription = boolvalFallbackTrue(dataset.showDescription)
  config.showChapters = boolvalFallbackTrue(dataset.showChapters)

  // Custom colour theme
  if (dataset.skinThemeColour && /^#[0-9A-F]{6}$/i.test(dataset.skinThemeColour)) {
    config.skin = {
      controlbar: {
        text: dataset.skinThemeColour,
        icons: hexToRGB(dataset.skinThemeColour, 0.8),
        iconsActive: dataset.skinThemeColour
      },
      timeslider: {
        progress: dataset.skinThemeColour
      }
    }
  }
  if (config.videoId == null && config.videoUrl == null) {
    throw new Error('videoId or videoUrl is required');
  }

  // interactive override
  if (hasOwn(dataset,'interactiveShowScrub')) {
    config.interactiveShowScrub = dataset.interactiveShowScrub !== 'false';
  }
  if (hasOwn(dataset, 'interactiveShowTimestamp')) {
    config.interactiveShowTimestamp = dataset.interactiveShowTimestamp !== 'false';
  }
  // origin
  config.origin = process.env.VUE_APP_SCRIPT_HOST
  config.origin = config.origin ? config.origin.replace(/\/$/, '') : '';

  // Analytics
  if (dataset.gaId) {
    config.gaId = dataset.gaId;
  }

  if (dataset.adobeTrackingScriptUrl) {
    config.adobeTrackingScriptUrl = dataset.adobeTrackingScriptUrl;
  }
  if (dataset.adobeTrackingDomain) {
    config.adobeTrackingDomain = dataset.adobeTrackingDomain;
  }
  if (dataset.adobeChanelName) {
    config.adobeChanelName = dataset.adobeChanelName;
  }
  if (dataset.adobeChanel) {
    config.adobeChanel = dataset.adobeChanel;
  }
  if (dataset.adobePageName) {
    config.adobePageName = dataset.adobePageName;
  }
  if (dataset.adobeMarketingCloudOrganizationId) {
    config.adobeMarketingCloudOrganizationId = dataset.adobeMarketingCloudOrganizationId;
  }
  if (dataset.adobeReportSuiteId) {
    config.adobeReportSuiteId = dataset.adobeReportSuiteId;
  }
  if (dataset.registrationId) {
    config.registrationId = dataset.registrationId ? dataset.registrationId : null;
  }

  config.disableInteractive = boolvalFallbackFalse(dataset.disableInteractive)
  config.disablePresentation = boolvalFallbackFalse(dataset.disablePresentation)

  if (dataset.customUnmute) {
    config.customUnmute = boolvalFallbackFalse(dataset.customUnmute);
  }
  if (dataset.customUnmuteText) {
    config.customUnmuteText = dataset.customUnmuteText;
  }

  config.theaterMode = ['on', 'off'].indexOf(dataset.theaterMode) > -1 ? dataset.theaterMode : false;

  // Token
  if (dataset.token) {
    config.token = dataset.token;
  }

  if (hasOwn(dataset, 'noCustomCss')) {
    config.noCustomCss = toBoolean(dataset.noCustomCss);
  }

  if (hasOwn(dataset, 'externalFullscreen')) {
    config.externalFullscreen = boolvalFallbackFalse(dataset.externalFullscreen);
  } else {
    config.externalFullscreen = false;
  }

  if (hasOwn(dataset, 'textTrackBackground')) {
    config.textTrackBackground = boolvalFallbackFalse(dataset.textTrackBackground);
  }

  return Object.assign({}, config);
}

function boolvalFallbackFalse(value) {
  return validator.isBoolean(value + '') ? value + '' === 'true' : false;
}
function boolvalFallbackTrue(value) {
  return validator.isBoolean(value + '') ? value + '' !== 'false' : true;
}

function hexToRGB(hex, alpha) {
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')';
  }
}

function hasOwn(o, p) {
  if (typeof Object.hasOwn === 'function') {
    return Object.hasOwn(o, p);
  } else {
    return o.hasOwnProperty(p);
  }
}

export function toHHMMSS(time) {
  time = time < 0 ? 0 : time;
  var hours =
    Math.floor(time / 3600) < 10
      ? ("00" + Math.floor(time / 3600)).slice(-2)
      : Math.floor(time / 3600);
  var minutes = ("00" + Math.floor((time % 3600) / 60)).slice(-2);
  var seconds = ("00" + Math.floor((time % 3600) % 60)).slice(-2);
  return (hours === "00" ? "" : hours + ":") + minutes + ":" + seconds;
}

function toBoolean(s)
{
  return !(typeof s === 'undefined' || s === null || s === '' || s.toLowerCase() === 'false');
}

export {
  filterConfig,
  hexToRGB,
}
